const UPDATE_FLAG = 'UPDATE_FLAG';
const CLOSE_PANEL = 'CLOSE_PANEL';
const SET_SELECT_SECTION_ID = 'SET_SELECT_SECTION_ID';
const SET_SELECT_PAGE_ID = 'SET_SELECT_PAGE_ID';
const SET_CUT_SECTION_ID = 'SET_CUT_SECTION_ID';
const RESET_CUT_SECTION_ID = 'RESET_CUT_SECTION_ID';
const SET_ADD_INDEX = 'SET_ADD_INDEX';
const CHANGE_FIELD_PANEL_CHANGE_MODE = 'CHANGE_FIELD_PANEL_CHANGE_MODE';
const SET_FOCUS_SETTING = 'SET_FOCUS_SETTING';
const UPDATE_TEMPID_SELECT = 'UPDATE_TEMPID_SELECT';
const UNSET_SELECT_SECTION_ID = 'UNSET_SELECT_SECTION_ID';

const initialState = {
    formVersion: 0,
    selectPageId: 0,
    selectSectionId: undefined,
    scrollEffect: false,
    selectSectionIndex: undefined,
    popupContent: '',
    popupPayload: {},
    fieldPanelChangeMode: false,
    fieldPanelChangeCategory: '',
    settingShowType: 'form',
    cutSectionPageId: undefined,
    cutSectionId: undefined,
    cutSectionType: undefined
};

export default function flag(currentState = initialState, action) {
    const state = { ...initialState, ...currentState };
    switch (action.type) {
        case UPDATE_FLAG: {
            return { ...state, ...action.payload };
        }
        case CLOSE_PANEL: {
            return { ...state, popupContent: '', popupPayload: {} };
        }
        case SET_SELECT_SECTION_ID: {
            const { selectId, scrollEffect, settingShowType = 'section' } = action.payload;
            return {
                ...state,
                selectSectionId: selectId,
                scrollEffect,
                settingShowType
            };
        }
        case UNSET_SELECT_SECTION_ID: {
            return {
                ...state,
                selectSectionId: '',
                settingShowType: ''
            };
        }
        case SET_SELECT_PAGE_ID: {
            const { selectPageId } = action.payload;
            return {
                ...state,
                selectPageId
            };
        }
        case SET_CUT_SECTION_ID: {
            const {
                payload: {
                    cutSectionPageId = undefined,
                    cutSectionId = undefined,
                    cutSectionType = undefined
                } = {}
            } = action;
            return { ...state, cutSectionPageId, cutSectionId, cutSectionType };
        }
        case RESET_CUT_SECTION_ID: {
            return { ...state, cutSectionId: undefined };
        }
        case SET_ADD_INDEX: {
            const { sectionIndex } = action.payload;
            return { ...state, selectSectionIndex: sectionIndex };
        }
        case UPDATE_TEMPID_SELECT: {
            const { selectSectionId, selectPageId } = action.payload;
            return { ...state, selectSectionId, selectPageId };
        }
        case SET_FOCUS_SETTING: {
            const { settingShowType } = action.payload;
            return { ...state, settingShowType };
        }
        case CHANGE_FIELD_PANEL_CHANGE_MODE: {
            return {
                ...state,
                fieldPanelChangeMode: action.payload.status,
                fieldPanelChangeCategory: action.payload.category
            };
        }
        default:
            return state;
    }
}

export function openPopupPanel(popupContent, popupPayload) {
    return {
        type: UPDATE_FLAG,
        payload: { popupContent, popupPayload }
    };
}

export function closePopupPanel() {
    return {
        type: CLOSE_PANEL
    };
}

export function selectSection(selectId, scrollEffect = false, settingShowType) {
    return {
        type: SET_SELECT_SECTION_ID,
        payload: {
            selectId,
            scrollEffect,
            settingShowType
        }
    };
}

export function unselectSection() {
    return {
        type: UNSET_SELECT_SECTION_ID
    };
}

export function setCutSectionId(sectionId) {
    return (dispatch, getState) => {
        const {
            flag: { selectPageId }
        } = getState();
        const cutSection = getState().sections.find(section => section.id === sectionId);
        dispatch({
            type: SET_CUT_SECTION_ID,
            payload: {
                cutSectionPageId: selectPageId,
                cutSectionId: sectionId,
                cutSectionType: cutSection.type
            }
        });
    };
}

export function resetCutSectionId() {
    return {
        type: RESET_CUT_SECTION_ID
    };
}

export function setAddIndex(index) {
    return {
        type: SET_ADD_INDEX,
        payload: { sectionIndex: index }
    };
}

export function changeFieldPanelChangeMode(status, category) {
    return {
        type: CHANGE_FIELD_PANEL_CHANGE_MODE,
        payload: {
            status,
            category
        }
    };
}

export function setFocusSetting(type) {
    return {
        type: SET_FOCUS_SETTING,
        payload: { settingShowType: type }
    };
}

export function openFieldPanelChangeMode(category) {
    return dispatch => {
        dispatch(openPopupPanel('questionPanel'));
        dispatch(changeFieldPanelChangeMode(true, category));
    };
}

export function closeFieldPanelChangeMode() {
    return dispatch => {
        dispatch(openPopupPanel(''));
        dispatch(changeFieldPanelChangeMode(false, ''));
    };
}

export function updateTempIdSelectFlag(checkSelectSectionId, checkSelectPageId) {
    return {
        type: UPDATE_TEMPID_SELECT,
        payload: {
            selectSectionId: checkSelectSectionId,
            selectPageId: checkSelectPageId
        }
    };
}

export function selectPage(pageId) {
    return {
        type: SET_SELECT_PAGE_ID,
        payload: {
            selectPageId: pageId
        }
    };
}
